<template lang="html">
    <d-list-group flush>
      <d-list-group-item class="p-0">
        <d-form @submit.prevent="submit()">
          <d-form-row>
            <d-col md="3" class="form-group">
              <label for="feResellerNational">Representante Nacional padrão</label>
              <autocomplete
                ref="resellerNational"
                placeholder="Representante nacional"
                parameter="national"
                :items="resellers"
                item-show="name"
                :on-input="onInput"
                :on-select="saveReseller"
              ></autocomplete>
            </d-col>
          </d-form-row>

          <d-form-row>
            <d-button type="submit" class="btn-primary">Salvar</d-button>
          </d-form-row>
        </d-form>

      </d-list-group-item>
    </d-list-group>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Autocomplete from '_shared/Autocomplete.vue';
import ResellerService from '_services/rest/modules/reseller';
import SettingsService from '_services/rest/modules/settings';
import { _LOAD_MODEL_SETTING_, SETTINGS } from './SettingsModel';

export default {
  name: 'settings-form',
  components: {
    Autocomplete,
  },
  data() {
    return {
      model: { ...SETTINGS },
      resellers: [],
    };
  },
  watch: {},
  methods: {
    ...mapActions([
      'activeAlert',
    ]),
    onInput(search) {
      const params = {
        search,
        skip: 0,
        take: 10,
        page: 1,
      };
      ResellerService.getList(params)
        .then(response => {
          this.resellers = response.list;
        });
    },
    loadReseller(reseller) {
      if (this.$refs.resellerNational && reseller.national) {
        this.$refs.resellerNational.$refs.input.value = reseller.national.name;
      }
    },
    save() {
      SettingsService.saveOptions(this.model, 'settings')
        .then(() => this.activeAlert({ message: 'Variáveis salvas com sucesso', theme: 'success' }))
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        })
        .finally(this.loading = false);
    },
    saveReseller(reseller) {
      this.model.resellerNational = reseller.id.toString();
    },
    submit() {
      this.loading = true;
      return this.save();
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_SETTING_, newValue => {
      const { resellerNational, reseller } = newValue;
      this.model = { resellerNational };
      this.loadReseller(reseller);
    });
  },
};
</script>

<style lang="scss" scoped>
.custom-file-label {
  overflow: hidden;
  white-space: nowrap;
}
</style>
